module.exports = __webpack_public_path__ + "static/img/step-03.b731cd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onedriveBuiness/step-03.png
// module id = cnmE
// module chunks = 1